import Navbar from "./Navbar/Navbar.js";
import Content from "./content.js";

const LandingPage=()=>{
    return(
        <>
        <Navbar/>
        <Content/>
        </>
    )
}
export default LandingPage;